import Card from 'src/ui/molecules/Card'
import { cards } from './cards'

const HomePage = () => {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {cards.map((card, key) => (
        <Card {...card} key={key} />
      ))}
    </div>
  )
}

export default HomePage
